module.exports = __webpack_public_path__ + "img/404.584c3e08.png";